import { DataSource, Label, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCustomerSummary extends Layout {
    labelCustomer: Label;
    labelFinancials: Label;
    labelOrder: Label;
    labelQuote: Label;
    panelCustomer: Panel;
    panelFinancials: Panel;
    panelOrder: Panel;
    panelQuote: Panel;
    sourceCustomerSummary: DataSource;
    textboxAvailableCredit: Textbox;
    textboxBalance: Textbox;
    textboxCreditLimit: Textbox;
    textboxLastCompletedActivity: Textbox;
    textboxLastContactDate: Textbox;
    textboxLastOrderDate: Textbox;
    textboxLastQuoteDate: Textbox;
    textboxOrderCount: Textbox;
    textboxQuoteCount: Textbox;
}
